import { render } from "./DateRangeChooserMaxSpan.vue?vue&type=template&id=3e7a459d&ts=true"
import script from "./DateRangeChooserMaxSpan.vue?vue&type=script&lang=ts"
export * from "./DateRangeChooserMaxSpan.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__